module.exports = "pegasus/assets/blocks/column-3-theme3.png";